export const SK_CMS_DATA = {
  ys: {},
  container: {},
  components: {},
  mainContainer: []
};

export const $renderComponent = {};
export const $renderComponentFn = {};